import { PlayerStatus } from '../../../shared/enums/poker-types';
import { environment } from '../../../../environments/environment';
import { SeatLayoutIndices as SeatLayoutIndicesVertical, SeatPositions as SeatPositionsVertical } from './table-vertical.const';
import { SeatLayoutIndices as SeatLayoutIndicesHorizontal, SeatPositions as SeatPositionsHorizontal } from './table-horizontal.const';

export class Common {

    public static isPlaying(playerStatus: PlayerStatus) {
        return playerStatus === PlayerStatus.Ready ||
            playerStatus === PlayerStatus.LeftNextHand ||
            playerStatus === PlayerStatus.SitoutNextHand;
    }

    // Derived from the seat's physical slot in SeatPositions (via SeatLayoutIndices), not a
    // hardcoded per-maxNumOfPlayers table: slot 0 is bottom-center, 1..half-1 run up the left
    // side, half is top-center, half+1..end run down the right side (mirror of the left side).
    public static isLeftSided(seatNumber: number, maxNumOfPlayers: number, useVerticalMode: boolean): boolean {
        const layoutIndices = useVerticalMode ? SeatLayoutIndicesVertical : SeatLayoutIndicesHorizontal;
        const totalPositions = (useVerticalMode ? SeatPositionsVertical : SeatPositionsHorizontal).length;

        const positionIndex = layoutIndices[maxNumOfPlayers]?.[seatNumber];
        if (positionIndex === undefined) {
            return true;
        }

        const half = totalPositions / 2;
        if (positionIndex === 0 || positionIndex === half) {
            return false;
        }
        return positionIndex < half;
    }

    public static isPotLeftSided(seatNumber: number, maxNumOfPlayers: number): boolean {
        if (maxNumOfPlayers === 10) {
            switch (seatNumber) {
                case 0: {
                    return false;
                }
                case 1:
                case 2:
                case 3:
                case 4:
                case 5: {
                    return true;
                }

                case 6:
                case 7:
                case 8:
                case 9: {
                    return false;
                }
            }
        } else if (maxNumOfPlayers === 9) {
            switch (seatNumber) {
                case 0: {
                    return false;
                }
                case 1:
                case 2:
                case 3:
                case 4: {
                    return true;
                }
                case 5:
                case 6:
                case 7:
                case 8: {
                    return false;
                }
            }
        } else if (maxNumOfPlayers === 8) {
            switch (seatNumber) {
                case 0: {
                    return false;
                }
                case 1:
                case 2:
                case 3:
                case 4: {
                    return true;
                }
                case 5:
                case 6:
                case 7: {
                    return true;
                }
            }
        } else if (maxNumOfPlayers === 6) {
            switch (seatNumber) {
                case 0: {
                    return false;
                }
                case 1:
                case 2:
                case 3: {
                    return true;
                }
                case 4:
                case 5: {
                    return false;
                }
            }
        } else if (maxNumOfPlayers === 2) {
            switch (seatNumber) {
                case 0: {
                    return true;
                }
                case 1: {
                    return false;
                }
            }
        } else {
            switch (seatNumber) {
                case 0: {
                    return false;
                }
                case 1:
                case 2:
                case 3:
                case 4:
                case 5: {
                    return true;
                }

                case 6:
                case 7:
                case 8:
                case 9: {
                    return false;
                }
            }
        }
    }

    public static parseTime(time: number): string {
        const secondsLeft: number = time % 60;
        const minutesLeft: number = time / 60;

        const strToRet = '';
        let minStr = '';
        let secStr = '';

        if (minutesLeft < 10) {
            minStr = '0' + Math.floor(minutesLeft).toString();
        } else {
            minStr = Math.floor(minutesLeft).toString();
        }

        if (secondsLeft < 10) {
            secStr = '0' + Math.floor(secondsLeft).toString();
        } else {
            secStr = Math.floor(secondsLeft).toString();
        }

        return minStr + ':' + secStr;
    }

    public static shiftFoward(steps: number, arr: any) {
        for (let i = 0; i < steps; i++) {
            arr.unshift(arr.pop());
        }
    }

    public static shiftBackwards(steps: number, arr: any) {
        for (let i = 0; i < steps; i++) {
            arr.push(arr.shift());
        }
    }
}
